import { WebApplicationConstants } from "../setup/WebApplicationConstants";
import { report } from "@/utils";

export async function globalWarnHandler(message: string, vm: Vue, trace: string) {
  await report.warning({ message: message + "in " + vm.$options.name + " (" + vm.$pageId + ")", isSourceVue: true, trace, vm, vmInfo: { name: vm.$options.name, id: vm.$pageId } }, WebApplicationConstants.show.errorOverlay);
}
